import { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import "./Sidebar.css";
import images from "../../utilities/images/images";

const isPathActive = (pathname, path) =>
  pathname === path || pathname.startsWith(`${path}/`);

const Sidebar = () => {
  const [collapsed, setCollapsed] = useState(false);
  const history = useHistory();
  const { pathname } = useLocation();

  const isStudyDashboard =
    pathname === "/dashboard" || pathname.startsWith("/dashboard/");

  return (
    <aside className={`sidebar ${collapsed ? "collapsed" : ""}`}>
      <div
        className={`sidebar-header ${
          collapsed ? "header-collapsed" : "header-open"
        }${isStudyDashboard ? " sidebar-header--study" : ""}`}
      >
        {!collapsed &&
          (isStudyDashboard ? (
            <div className="sidebar-study-brand">
              <button
                type="button"
                className="sidebar-brand"
                onClick={() => history.push("/dashboard")}
                aria-label="Go to study dashboard"
              >
                <img
                  src={images.motion_logo_new}
                  alt="Motion"
                  className="sidebar-brand-logo sidebar-brand-logo--study"
                />
              </button>
              <p className="sidebar-study-space">STUDY SPACE</p>
            </div>
          ) : (
            <button
              type="button"
              className="sidebar-brand"
              onClick={() => history.push("/user_dashboard")}
              aria-label="Go to dashboard"
            >
              <img
                src={images.motion_logo_new}
                alt="Motion"
                className="sidebar-brand-logo"
              />
            </button>
          ))}
        <button
          type="button"
          className="sidebar-collapse-btn"
          onClick={() => setCollapsed(!collapsed)}
          aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          <img
            src={images.sidebar_collapse}
            alt=""
            className="menu-icon"
            aria-hidden="true"
          />
        </button>
      </div>

      <nav className="sidebar-nav">
        <SidebarItem
          icon={images.homeImg}
          label="Dashboard"
          active={pathname === "/dashboard"}
          collapsed={collapsed}
          onClick={() => history.push("/dashboard")}
        />

        <SidebarItem
          icon={images.home}
          label="Home"
          active={pathname === "/user_dashboard"}
          collapsed={collapsed}
          onClick={() => history.push("/user_dashboard")}
        />

        <SidebarItem
          icon={images.myspace_icon}
          iconClassName="sidebar-icon--dark-on-light"
          label="My Space"
          active={isPathActive(pathname, "/my-space")}
          collapsed={collapsed}
          onClick={() => history.push("/my-space")}
        />

        <SidebarItem
          icon={images.model_training}
          label="Practice"
          active={isPathActive(pathname, "/practice")}
          collapsed={collapsed}
          onClick={() => history.push("/practice")}
        />

        <SidebarItem
          icon={images.help_outline}
          label="Doubts"
          active={isPathActive(pathname, "/doubts")}
          collapsed={collapsed}
          onClick={() => history.push("/doubts")}
        />

        <SidebarItem
          icon={images.storefront}
          label="Store"
          active={isPathActive(pathname, "/store")}
          collapsed={collapsed}
          onClick={() => history.push("/store")}
        />

        <SidebarItem
          icon={images.person_outline}
          label="Profile"
          active={
            pathname === "/user_edit_profile" || pathname === "/user_profile"
          }
          collapsed={collapsed}
          onClick={() => history.push("/user_edit_profile")}
        />
      </nav>
    </aside>
  );
};

const SidebarItem = ({
  icon,
  iconClassName = "",
  label,
  active,
  collapsed,
  onClick,
}) => {
  return (
    <div
      className={`sidebar-item ${active ? "active" : ""}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
    >
      <img
        src={icon}
        alt={label}
        className={["sidebar-icon", iconClassName].filter(Boolean).join(" ")}
      />
      {!collapsed && <span className="sidebar-label">{label}</span>}
    </div>
  );
};

export default Sidebar;
